<div class="row w-100 my-3 mx-auto">
  <div class="col-12">
    <mat-card class="mat-elevation-z4">
        <mat-card-title>
          <mat-toolbar class="p-0 no-bg border-bottom-1eee">
            <h2>{{'dashboard-page.title' | transloco}}</h2>
            <small class="ml-2">{{'dashboard-page.lastUpdateAt' | transloco}} {{lastUpdate$ | async | date:'dd/MM/yyyy HH:mm'}}</small>
            <span class="fill-remaining-space"></span>
            <a class="mat-elevation-z2" mat-mini-fab color="accent" title="{{'buttons.refresh' | transloco}}"
              (click)="refresh()">
              <mat-icon><i class="material-icons">refresh</i></mat-icon>
            </a>
          </mat-toolbar>
        </mat-card-title>
      </mat-card>
  </div>
</div>

<div class="row w-100 my-3 mx-auto">
  <div class="col-12">
    <app-aggregated #refreshable></app-aggregated>
  </div>
</div>

<div class="row w-100 my-3 mx-auto">
  <div class="col-12">
    <app-active-sessions #refreshable></app-active-sessions>
  </div>
</div>


<div class="row w-100 my-3 mx-auto">
  <div class="col-6">
    <app-active-users #refreshable></app-active-users>
  </div>
  <div class="col-6">
    <app-active-sessions-categories #refreshable></app-active-sessions-categories>
  </div>
</div>

